import { createElement as _createElement } from "react";
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import '../../../styles/custom-table-style.css';
import React from 'react';
import { useTable } from 'react-table';
import VnButton from '@ui/components/VnButton';
import { arrowDown, arrowUp, calendarOutline, funnelOutline, close } from 'ionicons/icons';
import { IonIcon } from '@ionic/react';
import { useAppDispatch } from '@application/store/useStore';
import { useParams } from 'react-router-dom';
import { formatDMY } from '@infrastructure/helpers';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Select from 'react-select';
import { gridHeaderDropdownStyle } from '@ui/styles/grid-header-dropdown-style';
const ArticleTableForm = ({ OnAddArticlePopupClose, onAddMaterialPopupClose, articals, onSorting, onFilter, defaultSortingCriteria, onRowClick }) => {
    const [sortingCriteria, setSortingCriteria] = useState(null);
    const [showFilters, setShowFilters] = useState(false);
    const [filterValues, setFilterValues] = useState({});
    const [addArticleConfirmationPopup, setAddArticleConfirmationPopup] = useState(false);
    const [articleRowData, setArticleRowData] = useState();
    const dispatch = useAppDispatch();
    const { id } = useParams();
    const columns = React.useMemo(() => [
        { Header: 'Artikelnr', accessor: 'articleNumber' },
        { Header: 'Naam', accessor: 'name' },
        { Header: 'Artikel groep', accessor: 'articleGroup' },
        { Header: 'Merk', accessor: 'brand' },
        { Header: 'Type', accessor: 'type' },
        { Header: 'Gegevens', accessor: 'data' },
        { Header: 'Leveranciers', accessor: 'supplierName' },
        { Header: 'Eenheid', accessor: 'unit' },
        { Header: 'Artikelnr Leveranciers', accessor: 'supplierArticleNumber' },
        { Header: 'Brutoprijs', accessor: 'grossPrice' },
        { Header: 'Korting', accessor: 'discount' },
        { Header: 'Nettoprijs', accessor: 'netPrice' },
        { Header: 'Verkoopprijs', accessor: 'sellingPrice' },
        { Header: 'Prijsdatum', accessor: 'priceDate', Cell: ({ value }) => _jsx(_Fragment, { children: value ? formatDMY(value.toString()) : '' }) },
        { Header: 'Voorraad', accessor: 'stock' }
    ], []);
    const data = React.useMemo(() => articals || [], [articals]);
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data });
    useEffect(() => {
        const newSortingCriteria = {
            sortColumnKey: defaultSortingCriteria.sortColumnKey,
            sortDirection: defaultSortingCriteria.sortDirection
        };
        setSortingCriteria(newSortingCriteria);
    }, []);
    const handleSort = (column) => {
        setSortingCriteria((prevSortingCriteria) => {
            const currentSortDirection = prevSortingCriteria?.sortDirection || 'asc';
            const sortDirection = column.id === prevSortingCriteria?.sortColumnKey ? (currentSortDirection === 'asc' ? 'desc' : 'asc') : 'asc';
            const newSortingCriteria = {
                sortColumnKey: column.id,
                sortDirection: sortDirection
            };
            onSorting(newSortingCriteria);
            return newSortingCriteria;
        });
    };
    const handleFilterChange = (columnId, value) => {
        setFilterValues((prevFilterValues) => {
            var updatedFilterValues = {
                ...prevFilterValues,
                [columnId]: value
            };
            if (typeof value === 'string' && value.length >= 2) {
                applyFilter(updatedFilterValues);
            }
            else if (value instanceof Date) {
                applyFilter(updatedFilterValues);
            }
            else if (typeof value != 'string' && typeof value != typeof Date) {
                applyFilter(updatedFilterValues);
            }
            if (typeof value === 'string' && value.length == 0) {
                const resetFilterValue = {
                    ...prevFilterValues,
                    [columnId]: null
                };
                updatedFilterValues = resetFilterValue;
                applyFilter(resetFilterValue);
            }
            return updatedFilterValues;
        });
    };
    const applyFilter = (filterValues) => {
        onFilter(filterValues);
    };
    const clearFilters = () => {
        const nullFilterValues = Object.fromEntries(Object.keys(filterValues).map((key) => [key, null]));
        setFilterValues({});
        setShowFilters(!showFilters);
        onFilter(nullFilterValues);
    };
    const handleRowClick = (data) => {
        //setAddArticleConfirmationPopup(true);
        // setArticleRowData(data.original);
        onRowClick(data.original);
        handleAddArticle();
    };
    const handleAddArticle = () => {
        if (articleRowData)
            onRowClick(articleRowData);
        OnAddArticlePopupClose();
        //onAddMaterialPopupClose();
    };
    const [datePickerIsOpen, setDatePickerIsOpen] = useState(false);
    const openPriceDatePicker = () => {
        setDatePickerIsOpen(!datePickerIsOpen);
    };
    const stockDropdown = [
        {
            label: 'Ja',
            value: 1
        },
        {
            label: 'Nee',
            value: 0
        }
    ];
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'd-flex justify-content-end mb-2 vn-filter-button-container', children: _jsx("div", { className: 'filter-header-container', children: _jsx(VnButton, { style: { borderRadius: '8px', minWidth: '41px', height: '37px', width: '20px' }, customClassName: !showFilters ? 'vn-header-buttons' : 'vn-header-buttons vn-table-filter-remove-button', icon: funnelOutline, customIconClassName: 'vn-filter-button-icon', mode: 'danger', onClick: () => {
                            !showFilters ? setShowFilters(!showFilters) : clearFilters();
                        } }) }) }), _jsx("div", { className: 'custom-table-container', children: _jsx("div", { className: 'vn-table-container', children: _jsx("div", { className: 'vn-main', children: _jsxs("table", { ...getTableProps(), className: 'table', children: [_jsx("thead", { className: 'vn-table-thead', children: headerGroups.map((headerGroup) => (_jsxs(React.Fragment, { children: [_jsx("tr", { ...headerGroup.getHeaderGroupProps(), className: 'vn-custom-grid-header-card', children: headerGroup.headers.map((column) => (_jsx("th", { ...column.getHeaderProps(), style: { cursor: 'pointer', padding: '16px' }, children: _jsxs("div", { onClick: () => handleSort(column), className: 'vn-grid-header-sort-inline header-caption', children: [column.render('Header'), sortingCriteria && sortingCriteria.sortColumnKey === column.id && (_jsx("span", { children: sortingCriteria.sortDirection === 'asc' ? (_jsx(IonIcon, { icon: arrowUp, className: 'ml-1 vn-grid-sorting-icon' })) : (_jsx(IonIcon, { icon: arrowDown, className: 'ml-1 vn-grid-sorting-icon' })) }))] }) }))) }), showFilters && (_jsx("tr", { children: headerGroup.headers.map((column) => (_jsx("td", { style: { borderBottomColor: '#80808047' }, children: column.id === 'priceDate' ? (_jsxs("div", { className: 'input-group', style: { width: '160px' }, children: [_jsx(DatePicker, { className: 'form-control vn-Input z-1070', open: datePickerIsOpen, onClickOutside: openPriceDatePicker, onChange: (date) => {
                                                                    handleFilterChange(column.id, moment(date).format('YYYY-MM-DD'));
                                                                    openPriceDatePicker();
                                                                }, dateFormat: 'dd/MM/yyyy', timeCaption: 'DateTime', showMonthDropdown: true, showYearDropdown: true, dropdownMode: 'select', value: filterValues[column.id]
                                                                    ? formatDMY(filterValues[column.id].toString())
                                                                    : formatDMY(filterValues[column.id]?.toString()), onCalendarClose: openPriceDatePicker, readOnly: true, onKeyDown: (e) => {
                                                                    if (e.key === 'Backspace') {
                                                                        handleFilterChange(column.id, null);
                                                                    }
                                                                } }), filterValues[column.id] && (_jsx("div", { className: 'input-group-append', children: _jsx(IonIcon, { icon: close, className: 'vn-Datepicker-Icon datepicker-cancel-icon', onClick: () => handleFilterChange(column.id, null) }) })), _jsx("div", { className: 'input-group-append', children: _jsx(IonIcon, { icon: calendarOutline, className: 'vn-Datepicker-Icon', onClick: openPriceDatePicker }) })] })) : column.id === 'stock' ? (_jsx("div", { style: { minHeight: '37px', marginLeft: '-6px' }, children: _jsx(Select, { menuPosition: 'fixed', isSearchable: false, styles: gridHeaderDropdownStyle, placeholder: 'Selecteer Status', value: stockDropdown?.find((option) => option.value === filterValues[column.id]), options: stockDropdown, onChange: (selectedOption) => {
                                                                if (column.id == 'stock') {
                                                                    handleFilterChange('stock', selectedOption ? selectedOption.value : undefined);
                                                                }
                                                            }, isClearable: true }) })) : column.id === 'grossPrice' ||
                                                        column.id === 'netPrice' ||
                                                        column.id === 'discount' ||
                                                        column.id === 'sellingPrice' ? (_jsx("div", { style: { width: '140px' }, children: _jsx("input", { className: 'form-control vn-Input', type: 'number', value: filterValues[column.id] || '', onChange: (e) => handleFilterChange(column.id, e.target.value) }) })) : (_jsx("div", { style: { width: '140px' }, children: _jsx("input", { className: 'form-control vn-Input', type: 'text', value: filterValues[column.id] || '', onChange: (e) => handleFilterChange(column.id, e.target.value) }) })) }, column.id))) }))] }, headerGroup.id ? headerGroup.id : 0))) }), rows && data && (_jsx("tbody", { ...getTableBodyProps(), className: 'vn-table-tbody', children: rows.map((row) => {
                                        prepareRow(row);
                                        return (_jsx("tr", { ...row.getRowProps(), style: { cursor: 'pointer' }, onClick: () => handleRowClick(row), children: row.cells.map((cell, index) => (_createElement("td", { ...cell.getCellProps(), key: index, style: { padding: '4px' } }, cell.column.id === 'stock' ? (_jsxs("label", { className: 'Vn-toggle-button-switch', onClick: (e) => {
                                                    e.stopPropagation();
                                                }, children: [_jsx("input", { type: 'checkbox', checked: cell.value == 1 ? true : false, disabled: true }, row.original.id), _jsx("span", { className: 'Vn-toggle-button-slider Vn-toggle-button-round' })] })) : (_jsx("span", { children: cell.render('Cell') }))))) }));
                                    }) }))] }) }) }) })] }));
};
export default ArticleTableForm;
